import { makeStyles } from '@material-ui/core/styles';

import { cardRadius, cardShadow, colors, typography } from '../../tokens';

const useStyles = makeStyles(theme => ({
  smallStatusCard: {
    height: '100%',
    minHeight: 138,
    padding: theme.spacing(2.5, 3),
    borderRadius: cardRadius,
    boxShadow: cardShadow,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      minHeight: 124,
      padding: theme.spacing(2),
    },
  },
  clickableCard: {
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0 3px 6px rgba(0,0,0,0.22)',
    },
  },
  statusHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  statusTitle: {
    color: colors.textSecondary,
    fontSize: typography.body.fontSize,
  },
  statusValueLine: {
    display: 'flex',
    alignItems: 'center',
  },
  statusIcon: {
    marginRight: theme.spacing(2.5),
    fontSize: 28,
  },
  statusValue: {
    color: colors.textPrimary,
    fontSize: typography.metricValue.fontSize,
    fontWeight: typography.metricValue.fontWeight,
    letterSpacing: typography.metricValue.letterSpacing,
    lineHeight: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 32,
    },
  },
  rowArrow: {
    color: colors.textSecondary,
    fontSize: 24,
  },
}));

export default useStyles;
